import { MonetizableEnum } from '@ria-client/segment/enums';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';

// badgeText: Theme/index.ts:1100; 1.2 has no Tailwind typography token.
const BADGE_TEXT_CLASS = 'text-xs leading-[1.2]';

export interface RiaDisclaimerProps {
  isFidelityOffer?: boolean;
  monetizable: MonetizableEnum;
  riaDisclaimerText: string;
}

export function RiaDisclaimer({
  isFidelityOffer = false,
  monetizable,
  riaDisclaimerText,
}: RiaDisclaimerProps) {
  const isMonetizing = monetizable === MonetizableEnum.yesAssumed;

  return (
    <div className="flex w-auto flex-wrap gap-2">
      {isMonetizing ? (
        <div className="flex max-w-fit items-center rounded-sm bg-[var(--content-yellow-lightest)] p-2">
          <span className={BADGE_TEXT_CLASS}>AD</span>
        </div>
      ) : null}
      <div className="flex items-center justify-between rounded-sm bg-[var(--content-yellow-lightest)] p-2">
        <span className={`pr-px ${BADGE_TEXT_CLASS}`}>{riaDisclaimerText}</span>
        {isMonetizing ? (
          // Body links are plain <a>: tooltip content remounts per open, so ContentLink would re-fire Link Viewed.
          <DisclosureTooltip
            className="max-w-[400px]"
            trigger={
              <button
                aria-label="Toggle Ria offer disclaimer"
                className="ml-1 whitespace-nowrap bg-transparent p-0 text-left text-muted-foreground"
                type="button"
              >
                <CircleHelp aria-hidden size={20} />
              </button>
            }
          >
            <span className="typography-text">
              {isFidelityOffer ? (
                <>
                  Paid non-advisory client promotion. NerdWallet maintains a 401k program and equity
                  management program through affiliates of this provider; NerdWallet doesn't invest
                  its money with this provider, but they are our referral partner - so we get paid
                  only if you click through and take a qualifying action. Being a referral partner
                  influences which products we write about and where and how the product appears on
                  our webpage. Most importantly, however, the content of our reviews and ratings are
                  objective and are never impacted by our partnerships. Our opinions are our own.
                  Here is a{' '}
                  <a href="https://www.nerdwallet.com/p/our-partners">list of our partners</a> and{' '}
                  <a href="https://www.nerdwallet.com/p/advertiser-disclosure">
                    here’s how we make money
                  </a>
                  .
                </>
              ) : (
                <>
                  NerdWallet doesn’t invest its money with this provider, but they are our referral
                  partner – so we get paid only if you click through and take a qualifying action
                  (such as open an account with or provide your contact information to the
                  provider). Most importantly, our reviews and ratings are objective and are never
                  impacted by our partnerships. Our opinions are our own. Here is a list of{' '}
                  <a href="https://www.nerdwallet.com/p/our-partners">our partners</a> and{' '}
                  <a href="https://www.nerdwallet.com/p/advertiser-disclosure">
                    here’s how we make money
                  </a>
                  .
                </>
              )}
            </span>
          </DisclosureTooltip>
        ) : null}
      </div>
    </div>
  );
}
